import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin.jsx";
import { STORE_KEYS } from "../../other/constants/StoreKeys.jsx";
import { getAging } from "../../other/utils/utils.jsx";
import { INCENTIVE_FILTER_ENTITY_TYPES, INCENTIVE_TYPES, INCENTIVE_TYPES_VALUES, OUTCOME_INCENTIVE_STATUS } from "@/other/constants/IncentiveKeys.jsx";

export class OutcomeIncentive extends HasProjectMixin(Model) {
  static get $name() {
    return "OutcomeIncentive";
  }

  static get relations() {
    return {
      // Todo: the relation doesn't work properly, It also does not work on other models where we used this. Added the getter below to get the creator name
      creatorRecord: {
        foreignKey: "creatorId",
        foreignStore: STORE_KEYS.boardUserStore,
      },
      updaterRecord: {
        foreignKey: "updaterId",
        foreignStore: STORE_KEYS.boardUserStore,
      }
    }
  }

  static get fields() {
    return [
      { name: "name", dataSource: "name" },
      { name: "points", dataSource: "points", type: "number", defaultValue: 0 },
      { name: "type", dataSource: "type", defaultValue: INCENTIVE_TYPES.OUTCOME },
      { name: "startDate", dataSource: "start_date", type: "date", defaultValue: new Date() },
      { name: "endDate", dataSource: "end_date", type: "date" },
      { name: "multiplyByDays", dataSource: "multiply_by_days", type: "boolean", defaultValue: false },
      { name: "status", dataSource: "status", defaultValue: OUTCOME_INCENTIVE_STATUS.ACTIVE },
      { name: "isLocked", dataSource: "is_locked", type: "boolean" },
      { name: "archived", dataSource: "archived", type: "boolean" },
      { name: "boardId", dataSource: "board" },
      { name: "creatorId", dataSource: "creator" },
      { name: "updaterId", dataSource: "updater" },
      { name: "createdAt", dataSource: "created_at", type: "date" },
      { name: "updatedAt", dataSource: "updated_at", type: "date" },
    ];
  }

  get aging() {
    return getAging(this.get("createdAt"));
  }

  get creatorUserName() {
    if (this.project && this.creatorId) {
      return this.project.boardUsersStore.getById(this.creatorId)?.name;
    }
    return 'N/A'
  }

  get incentiveType() {
    return INCENTIVE_TYPES_VALUES[this.get("type")];
  }

  get filterStore () {
    return this.project?.getCrudStore(STORE_KEYS.outcomeIncentiveConditionsStore);
  }

  get taskFilter() {
    return this.filterStore?.query((condition) => condition.incentiveId === this.id && condition.entityType === INCENTIVE_FILTER_ENTITY_TYPES.TASK, true);
  }

  get resourceFilter() {
    return this.filterStore?.query((condition) => condition.incentiveId === this.id && condition.entityType === INCENTIVE_FILTER_ENTITY_TYPES.RESOURCE, true);
  }
}
